import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SecureGuard } from './secure/secure.guard';


const routes: Routes = [{
    path: '',
    loadChildren: () => import('./landing-page/landing-page.module').then(m => m.PortalPageModule)
},
{
    path: '**',
    loadChildren: () => import('./not-found/not-found.module').then(m => m.NotFoundModule),
    data: {
        breadcrumb: 'Not Found',
    },
}];

@NgModule({
    imports: [RouterModule.forRoot(
        routes,
        {
            scrollPositionRestoration: 'top'
        })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
